// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fyy9","footer":"styles_footer__1ZRrO"};